export enum TargetType {
  BLANK = '_blank',
  SELF = '_self',
}
